/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse,
    DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseToJSON,
    DigitizingserviceMelcoModelsError,
    DigitizingserviceMelcoModelsErrorFromJSON,
    DigitizingserviceMelcoModelsErrorToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItemToJSON,
} from '../models';

export interface DigitizingServiceDefaultsApiDigitizingGetDefaultMeasurementUnitRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetDeliveryOptionsRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetEmbOutlineFormatsRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetEmbStitchFormatsRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetFabricColorsRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetFabricTypesRequest {
    vendorId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetLocationsRequest {
    vendorId?: string;
    productTypeId?: string;
}

export interface DigitizingServiceDefaultsApiDigitizingGetProductTypesRequest {
    vendorId?: string;
}

/**
 * 
 */
export class DigitizingServiceDefaultsApi extends runtime.BaseAPI {

    /**
     */
    async digitizingGetAvailableAppsRaw(): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/apps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetAvailableApps(): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsAppListItem> {
        const response = await this.digitizingGetAvailableAppsRaw();
        return await response.value();
    }

    /**
     */
    async digitizingGetDefaultMeasurementUnitRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetDefaultMeasurementUnitRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/measurementunit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetDefaultMeasurementUnit(requestParameters: DigitizingServiceDefaultsApiDigitizingGetDefaultMeasurementUnitRequest): Promise<DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse> {
        const response = await this.digitizingGetDefaultMeasurementUnitRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetDeliveryOptionsRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetDeliveryOptionsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/deliveryoptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetDeliveryOptions(requestParameters: DigitizingServiceDefaultsApiDigitizingGetDeliveryOptionsRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsDeliveryOptionListItem> {
        const response = await this.digitizingGetDeliveryOptionsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetEmbOutlineFormatsRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetEmbOutlineFormatsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/embroidery/outlineformats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetEmbOutlineFormats(requestParameters: DigitizingServiceDefaultsApiDigitizingGetEmbOutlineFormatsRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbOutlineFormatListItem> {
        const response = await this.digitizingGetEmbOutlineFormatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetEmbStitchFormatsRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetEmbStitchFormatsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/embroidery/stitchformats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetEmbStitchFormats(requestParameters: DigitizingServiceDefaultsApiDigitizingGetEmbStitchFormatsRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsEmbStitchFormatListItem> {
        const response = await this.digitizingGetEmbStitchFormatsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetFabricColorsRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetFabricColorsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/fabrics/colors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetFabricColors(requestParameters: DigitizingServiceDefaultsApiDigitizingGetFabricColorsRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricColorListItem> {
        const response = await this.digitizingGetFabricColorsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetFabricTypesRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetFabricTypesRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/fabrics/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetFabricTypes(requestParameters: DigitizingServiceDefaultsApiDigitizingGetFabricTypesRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem> {
        const response = await this.digitizingGetFabricTypesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetLocationsRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetLocationsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        if (requestParameters.productTypeId !== undefined) {
            queryParameters['product_type_id'] = requestParameters.productTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/products/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetLocations(requestParameters: DigitizingServiceDefaultsApiDigitizingGetLocationsRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsLocationListItem> {
        const response = await this.digitizingGetLocationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetProductTypesRaw(requestParameters: DigitizingServiceDefaultsApiDigitizingGetProductTypesRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/products/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetProductTypes(requestParameters: DigitizingServiceDefaultsApiDigitizingGetProductTypesRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem> {
        const response = await this.digitizingGetProductTypesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingGetVendorsRaw(): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/defaults/vendors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingGetVendors(): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsVendorListItem> {
        const response = await this.digitizingGetVendorsRaw();
        return await response.value();
    }

}
